import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CalsoftService } from 'src/app/services/Calsoft.service';
import { CommonService } from 'src/app/services/common.service';
import { ConfigServiceService } from 'src/app/services/config-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'calsoft-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent implements OnInit {
  @Input() type: string;
  @Input() component: string = "dark";
  public serverPath = environment.commonImageApi + "logo/";
  @Input() sitename: string;
  data: any;
  layout: any;
  defaultImage = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
  websiteLogoSize: any;
  configData: any;
  constructor(private calsoftService: CalsoftService, private commonService: CommonService,
    private route: Router
  ) { }
  ngOnInit() {

    const storedConfig = this.commonService.getConfigData();

    if (storedConfig) {
      this.configData = JSON.parse(storedConfig);
      if (this.configData != null) {
        this.getConfigData();
      }

    } else {
      console.warn('No config data found in localStorage.');
    }


  }

  closeMenu() {

    if (this.component == "menu") {
      this.calsoftService.sidenavOpen = false;
    } else {

      if (this.route.url != '/home') {
        this.route.navigate(['/']);
      }

    }

  }
  getConfigData() {
    // const storedConfig = this.commonService.getConfigData();

    // if (storedConfig) {
    //   this.configData = JSON.parse(storedConfig);


    //   // You can now use this.configData.theme, token, etc.
    // } else {
    //   console.warn('No config data found in localStorage.');
    // }

    let data = this.configData;
    this.websiteLogoSize = data['websiteLogoSize'];


  }

}
